import { Navigate, Outlet, useParams } from 'react-router-dom'
import FullPageLoader from '@/components/loaders/FullPageLoader'
import { RuntimeFeatureFlag } from '@/feature-flags/definitions'
import { useRuntimeFeatureFlag } from '@/feature-flags/useRuntimeFeatureFlag'
import { selectMatterById } from '@/matter/store/selectors'
import { MatterViewerRole } from '@/matter/store/schemas'
import { canEditMedChron } from '@/matter/utils/matter-permissions'
import { matterPaths } from '@/routing/paths'
import { useAppSelector } from '@/store/store-hooks'

/** Wait for the Editor capability decision before mounting a chronology write route. */
export default function MedChronEditGuard() {
  const { matterId } = useParams<{ matterId: string }>()
  const matter = useAppSelector((state) => selectMatterById(state, { matterId: matterId ?? null }))
  const { enabled, loading } = useRuntimeFeatureFlag(RuntimeFeatureFlag.COLLAB_EDITOR_ROLE)
  if (!matter || !matterId) return <FullPageLoader />
  if (matter.viewer_role !== MatterViewerRole.Owner && loading) return <FullPageLoader />
  return canEditMedChron(matter, enabled && !loading) ? <Outlet /> : <Navigate to={matterPaths.chronology.index(matterId)} replace />
}
